"use client";

import * as React from "react";
import { RWA_ICON } from "~/consts";
import { getButtonClassName } from "~/components/Button";

import type { JSX } from "react";

// // // //

/**
 * Error
 * Route-level error boundary for the App Router.
 *
 * The Pages Router falls back to Next.js' built-in `_error` page; the App
 * Router has no built-in equivalent, so every app route needs this boundary.
 *
 * NOTE - error boundaries must be Client Components.
 */
export default function Error(props: {
    error: Error & { digest?: string };
    retry: () => void;
}): JSX.Element {
    const { error, retry } = props;

    React.useEffect(() => {
        // NOTE - errors thrown on the server only expose `digest` here; use it
        // to match the full stack trace in the server logs
        console.error(error);
    }, [error]);

    return (
        <div className="min-h-screen pt-16 pb-12 flex flex-col select-none">
            <main className="grow flex flex-col justify-center max-w-7xl w-full mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex flex-col gap-4 items-center select-none">
                    <img src={RWA_ICON} alt="RWA.xyz" className="h-18" />
                </div>

                <div className="pb-16 pt-6">
                    <div className="text-center">
                        <h1 className="text-4xl text-foreground tracking-tight sm:text-5xl">
                            Something went wrong.
                        </h1>
                        <p className="mt-6 text-xl text-foreground">
                            {
                                "Sorry, we hit an unexpected error loading this page."
                            }
                        </p>
                        {error.digest && (
                            <p className="mt-2 text-sm text-muted-foreground">
                                Reference: {error.digest}
                            </p>
                        )}
                        <div className="mt-6 flex justify-center">
                            <button
                                type="button"
                                onClick={() => retry()}
                                className={getButtonClassName({})}
                            >
                                Try again
                            </button>
                        </div>
                    </div>
                </div>
            </main>
        </div>
    );
}
